export function InitialTimeDirective(availabilitiesFactory, restaurantHoursService) {
    'ngInject';
    return {
        restrict: 'E',
        replace: false,
        link: function(scope, elem, attrs) {
            availabilitiesFactory.setInitialDateTime(attrs.payload);
            restaurantHoursService.setInitialDateTime(attrs.payload);
        }
    };
}
